'use client';

import { calculateTotalDiscountPerPriority, formatIDR } from '@/lib/utils';
import React, { useMemo } from 'react';
import { BetweenHorizonalStart } from 'lucide-react';
import { HttpTypes } from '@/types';
import { ElementProps } from '@/components/sections/builder/types';
import { usePromotionStore } from '@/stores/promotion';
import { shallow } from 'zustand/shallow';

const defaultData: { name: string } = {
  name: 'Subtotal price',
};

export const ElementContent = ({ element, theme }: ElementProps<HttpTypes.StoreCart>) => {
  const data = (element.parentData || {}) as HttpTypes.StoreCart;
  const carts = data as HttpTypes.StoreCart;
  const cartItems = carts?.items || [];

  const { selectedPromotion } = usePromotionStore(
    (state) => ({
      selectedPromotion: state.selectedPromotion,
    }),
    shallow
  );

  const subtotal = useMemo(() => {
    return cartItems.reduce((total, item) => {
      const price = Number(
        Number(item.discount_price) > 0 && Number(item.discount_price) < Number(item.sell_price)
          ? item.discount_price
          : item.sell_price
      );
      return total + price * item.quantity;
    }, 0);
  }, [cartItems]);

  const discount = useMemo(() => {
    return calculateTotalDiscountPerPriority(selectedPromotion, subtotal);
  }, [selectedPromotion, subtotal]);

  return (
    <div
      className='theme_cart_page_color my-4'
      style={
        {
          '--text-secondary': theme?.cart?.pageCartColorScheme.textSecondary || 'inherit',
        } as React.CSSProperties
      }
    >
      <p className='mb-1 text-base '>
        Estimated total {formatIDR(Math.max(subtotal - discount.totalDiscount, 0))}
      </p>
      {discount.totalDiscount > 0 && (
        <p className='mb-1 text-base text-[--text-secondary]'>
          Saved {formatIDR(discount.totalDiscount)}
        </p>
      )}
      <p>Taxes, discounts and shipping calculated at checkout.</p>
    </div>
  );
};

export const ElementPreviewIcon = BetweenHorizonalStart;

export function ElementSetting() {
  return <div></div>;
}

const CartSubtotalPrice = {
  type: 'cart_subtotal_price',
  group: 'cart_total',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  childs: [],
  maxEntries: 1,
};

export default CartSubtotalPrice;
